// extracted by mini-css-extract-plugin
export default {"twoCol":"styles_twoCol__el5WD","directions":"styles_directions__4gV5C"};